/**
 * Utility functions for managing cookies
 */

const EXPIRED = 'expires=Thu, 01 Jan 1970 00:00:00 GMT';

export const setCookie = (name: string, value: string, days: number = 365): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Deletes a cookie for this host and for every parent domain of it. Our own
 * cookies sit on the exact host, but third parties like Google Analytics set
 * theirs on the registrable domain - a plain delete would leave those behind,
 * and a withdrawn consent has to remove them too.
 */
export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;${EXPIRED};path=/`;

  const parts = window.location.hostname.split('.');
  for (let i = 0; i < parts.length - 1; i++) {
    const domain = parts.slice(i).join('.');
    document.cookie = `${name}=;${EXPIRED};path=/;domain=${domain}`;
    document.cookie = `${name}=;${EXPIRED};path=/;domain=.${domain}`;
  }
};

/** Every cookie name currently readable from JavaScript. */
export const getCookieNames = (): string[] =>
  document.cookie
    .split(';')
    .map((cookie) => cookie.split('=')[0].trim())
    .filter(Boolean);
